// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading_36LER","inner":"Loading_inner_2CpW8","icon":"Loading_icon_3mFJ5","loader-spin":"Loading_loader-spin_2dZ9m","loader-stroke":"Loading_loader-stroke_gYfmh"};